import { object, string, number, date, InferType, array } from 'yup';

export const contactSchema = object({
  name: string().min(1, 'Please enter a name').required('Please enter a name'),
  email: string().email(' Please enter a valid email').required('Please enter an email'),
  phoneNumber: string(),
  interests: array().min(1, 'Please select atleas one option'),
  message: string(),
});
